import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import EnsembleSection from './components/EnsembleSection';
import CredentialsSection from './components/CredentialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import JsonLd from '../../components/feature/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: '日本音楽藝術表現研究所',
      alternateName: 'Institute of Japanese Musical Art Expression',
      url: siteUrl,
      description:
        '島国の感性を基盤に、日本音楽の身体知を分析・再構築する研究機関。伝統的な音楽の潮流を統合的に捉え、現代のアート、エンターテインメント、エデュケーションへと実装します。',
      founder: { '@type': 'Person', name: 'Shogo Yoshii' },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: '日本音楽藝術表現研究所',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ja',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: '日本音楽藝術表現研究所 | Institute of Japanese Musical Art Expression',
      description:
        '島国の感性を基盤に、日本音楽の身体知を分析・再構築する研究機関。伝統的な音楽の潮流を統合的に捉え、現代のアート、エンターテインメント、エデュケーションへと実装します。',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ja',
    },
  ],
};

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white">
      <title>日本音楽藝術表現研究所 | Institute of Japanese Musical Art Expression</title>
      <meta
        name="description"
        content="島国の感性を基盤に、日本音楽の身体知を分析・再構築する研究機関。伝統的な音楽の潮流を統合的に捉え、現代のアート、エンターテインメント、エデュケーションへと実装します。Produced by Shogo Yoshii"
      />
      <meta name="keywords" content="日本音楽,音楽研究,文化芸術,アンサンブル,伝統音楽,Shogo Yoshii" />
      <link rel="canonical" href={siteUrl || '/'} />
      <meta property="og:url" content={siteUrl} />
      <JsonLd data={homeJsonLd} id="home" />
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <PhilosophySection />
      <EnsembleSection />
      <CredentialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
